var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wombat-row-default-cell role"},[_vm._v(" "+_vm._s(_vm.item[_vm.column.field])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }